import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2024 Akka Roti. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
